import React from 'react';
import { Button, Form, Input, Divider } from 'antd';
import InputLabel from '@frontend/components/label/InputLabel'
import { GeneralModalButtons } from '@rankmi/ats-app'
const text = (
  <InputLabel label='Nombre del motivo*' />
)



const ReasonForm = ({ onSubmit, reasonSelected = {}, onCancel, form }) => {

	const { description } = reasonSelected || '';
	return (
		<Form hideRequiredMark layout='vertical' onSubmit={e => onSubmit(e, form)}>
			<Form.Item label={text} name='description'>
				{form.getFieldDecorator('description', {
					initialValue: description,
					rules: [
						{
							required: true,
							message: 'Es necesario agregar el nombre del motivo',
						},
					],
				})(<Input placeholder='Escribe el motivo'/>)}
        <GeneralModalButtons onCancel={onCancel} />
			</Form.Item>
		</Form>
	);
};

const AddEditReasonForm = Form.create({ name: 'reason-form' })(ReasonForm);

export default AddEditReasonForm;
